import React, { useRef, useState } from "react";
import { modal } from "./useModal";
import AvatarEditor from "react-avatar-editor";
import { IoClose, IoCheckmark } from "react-icons/io5";
import { HiMinus, HiPlus } from "react-icons/hi2";
import "./imageCropper.css";

const MAX_CROP_DIMENSION = 1600;
const JPEG_QUALITY = 0.84;

const resizeCanvasIfNeeded = (sourceCanvas) => {
  const { width, height } = sourceCanvas;
  const longestSide = Math.max(width, height);

  if (longestSide <= MAX_CROP_DIMENSION) {
    return sourceCanvas;
  }

  const scale = MAX_CROP_DIMENSION / longestSide;
  const outputCanvas = document.createElement("canvas");
  outputCanvas.width = Math.round(width * scale);
  outputCanvas.height = Math.round(height * scale);

  const context = outputCanvas.getContext("2d");
  context.drawImage(sourceCanvas, 0, 0, outputCanvas.width, outputCanvas.height);

  return outputCanvas;
};

const canvasToBlob = (canvas) => {
  return new Promise((resolve) => {
    canvas.toBlob(resolve, "image/jpeg", JPEG_QUALITY);
  });
};

const ImageCropper = (props) => {
  const { image, proceed, borderRadius, border, width, height } = props;
  const imageCropRef = useRef();
  const [cropZoom, setCropZoom] = useState(50);

  const handleCropSave = async () => {
    const sourceCanvas = imageCropRef.current.getImage();
    const outputCanvas = resizeCanvasIfNeeded(sourceCanvas);
    const blob = await canvasToBlob(outputCanvas);
    if (!blob) {
      proceed(false);
      return;
    }
    const base64 = outputCanvas.toDataURL("image/jpeg", JPEG_QUALITY);

    proceed({ base64, blob, mimeType: "image/jpeg" });
  };

  const handleZoomChange = (delta) => {
    setCropZoom(prev => Math.max(0, Math.min(100, prev + delta)));
  };

  return (
    <div className="image-cropper">
      <div className="image-cropper__editor">
      <AvatarEditor
          width={width || 280}
          height={height || 280}
          color={[0, 0, 0, 0.92]}
        ref={imageCropRef}
        image={image?.base64}
          border={border !== undefined ? border : 40}
          borderRadius={borderRadius !== undefined ? borderRadius : 0}
        scale={1 + cropZoom / 100}
      />
      </div>

      <div className="image-cropper__controls">
        <button
          className="image-cropper__btn image-cropper__btn--cancel"
          onClick={() => proceed(false)}
          type="button"
        >
          <IoClose size={22} />
        </button>

        <div className="image-cropper__zoom">
          <button
            className="image-cropper__zoom-btn"
            onClick={() => handleZoomChange(-10)}
            type="button"
          >
            <HiMinus size={16} />
          </button>
        <input
          type="range"
            className="image-cropper__slider"
          value={cropZoom}
            onChange={(e) => setCropZoom(Number(e.target.value))}
          min={0}
          max={100}
        />
          <button
            className="image-cropper__zoom-btn"
            onClick={() => handleZoomChange(10)}
            type="button"
          >
            <HiPlus size={16} />
          </button>
        </div>

        <button
          className="image-cropper__btn image-cropper__btn--confirm"
          onClick={handleCropSave}
          type="button"
        >
          <IoCheckmark size={22} />
        </button>
      </div>
    </div>
  );
};

export const cropImageModal = async (props) => {
  return await modal(ImageCropper, { props, raw: true });
};

export default ImageCropper;
